import { EnvironmentNameEnum } from './environment.enum';

export const environment = {
  appInsights: {
    instrumentationKey: '#{APP_INSIGHTS_KEY}#',
    logErrors: true,
    correlationHeaderExcludedDomains: ['*.mixpanel.com'],
  },
  azureAtlasKey: '',
  B2CConfig: 'config.json',
  encryptionKey: '1234567890123456',
  encryptionIV: 'abcdef9876543210',
  imageTokenEndpoint: 'Utils/generate-images-sas-tokens',
  mixPanel: {
    mixpanelToken: '',
  },
  name: EnvironmentNameEnum.PROD,
  production: true,
  solutionGeneratorLink: '#{SOL_AGENT_URL}#',
  versionCheckURL: './version.json',
};
